export default __webpack_public_path__ + "static/media/Gmail-Logo.9bb0526b.png";